package com.macrofocus.eflux.animation

import kotlin.math.max
import kotlin.math.min

abstract class AbstractAnimation : Animation {
    protected fun interpolate(start: Double, end: Double, normalizedTime: Double, easing: Easing = Easing.LINEAR): Double {
        val cappedTime = max(0.0, min(1.0, normalizedTime))

        val diff = end - start
        //            property.value = startValue + (diff * normalizedTime)
        val eased = easing.ease(cappedTime, start, diff, 1.0).toDouble()
        val min = min(start, end)
        val max = max(start, end)
        val capped = max(min, min(max, eased))
        return capped
    }
}